import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import Error                 from "../../../domain/fundamentals/message/error/Error";
import ErrorMessage          from "../../../domain/fundamentals/message/error/ErrorMessage";
import ErrorRepository       from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors                from "../../../domain/fundamentals/message/error/Errors";
import ErrorTarget           from "../../../domain/fundamentals/message/error/ErrorTarget";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Plan                  from "../../../domain/plan/Plan";
import PlanRepository        from "../../../domain/plan/PlanRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ErrorDataSource       from "../../../infrastructure/datasource/error/ErrorDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import PlanDataSource        from "../../../infrastructure/datasource/plan/PlanDataSource";
import RouterDispatcher      from "../../../infrastructure/redux/router/RouterDispatcher";

class UpdatePlan {
  constructor(
    private readonly dispatch,
    private readonly planRepository: PlanRepository = new PlanDataSource(),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
    private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(dispatch),
  ) {
  }


  public async execute(plan: Plan) {
    try {
      this.fetchStatusRepository.start();
      await this.planRepository.update(plan);
      this.notifyRepository.saveSuccess();
      this.routerDispatcher.plans();
    } catch (e) {
      const list: Error[] = e.response.data.errors.map(error => new Error(new ErrorTarget(error.target), new ErrorMessage(error.message)));
      this.notifyRepository.saveFailure();
      this.errorRepository.set(new Errors(list));
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdatePlan;
